import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import EmployeeProfileCard from "./components/EmployeeProfileCard";

import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useLocation, useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import {
  useDailyCallByAttendance,
  useGetExpenseSingleDateById,
} from "./hooks/useEmployee";
import { useEffect, useState } from "react";

const DailyCallView = () => {
  const location = useLocation();
  const Navigate = useNavigate();
    const [filtersState, setFiltersState] = useState<any>({

    limit: 10,
    page: 1,
    search: null,
  });

  console.log(location.state); // Output: /employee/DailyCallView

  const formatDateTime = (dateTimeStr: string) => {
    const date = new Date(dateTimeStr);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
    });

    return `${formattedDate} ${formattedTime}`;
  };

  const CallsListColumn = () => [
    {
      name: "Working",
      selector: (row: { Agendacontroltype: string }) => row.Agendacontroltype,
      sortable: true,
      width: "130px",
    },
    {
      name: "Outlet Code",
      selector: (row: { OutletCode: string }) => row.OutletCode,
      sortable: true,
      width: "150px",
    },
    {
      name: "Outlet Name",
      selector: (row: { OutletName: string }) => row.OutletName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Outlet Type",
      selector: (row: { OutlettypeName: string }) => row.OutlettypeName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Town Name",
      selector: (row: { Stownname: string }) => row.Stownname || "-",

      sortable: true,
      width: "130px",
    },

    {
      name: "DCR Status",
      selector: (row: { DcrStatus: string }) => row.DcrStatus || "-",
      sortable: true,
      width: "130px",
    },
    {
      name: "Planned Calls",
      selector: (row: { Planned: string }) => row.Planned || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: "Detailing Brand Name",
      selector: (row: { Brands: { BrandName: string }[] }) =>
        row.Brands && row.Brands.length > 0
          ? row.Brands.map((b) => b.BrandName).join(", ")
          : "-",
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "SGPI",
      selector: (row: { SgpiOut: string }) => row.SgpiOut || "-",
      sortable: true,
      wrap: true,
      width: "130px",
    },
    {
      name: "Manager Designation",
      selector: (row: { ManagerDesignation: string }) =>
        row.ManagerDesignation
          ? row.ManagerDesignation.split(", ")
              .map((item: string) => item.trim())
              .join(", ")
          : "-",
      sortable: true,
      wrap: true,
      width: "200px",
    },
    {
      name: "Manager",
      selector: (row: { ManagersData: any[] }) =>
        row.ManagersData?.length
          ? row.ManagersData.map(
              (item: any) => `${item.FirstName} ${item.LastName}`
            ).join(", ")
          : "-",
      sortable: true,
      wrap: true,
      width: "200px",
    },

    {
      name: "POB Amount",
      selector: (row: { PobTotal: string }) => row.PobTotal || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: "Ed. Duration",
      selector: (row: { EdDuration: string }) => row.EdDuration || "-",
      sortable: true,
      width: "150px",
    },
    {
      name: "Updated Time",
      selector: (row: { UpdatedAt: any }) =>
        formatDateTime(row.UpdatedAt) || "-",
      sortable: true,
      wrap: true,
      width: "150px",
    },
  ];

  const CustomStyle = {
    imageContainer: {
      width: "75%",
      height: "50%",
      // borderRadius: "50%",
      overflow: "hidden",
      marginBottom: "16px",
      // backgroundColor: "#fff",
      marginLeft: "16xp",
    },
    image: {
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      ObjectFit: "cover",
    },
  };

  const ExpenseListColumn = (handleExpenseView: (row: any) => void) => [
    {
      name: "Date",
      selector: (row: { expenseDate: any }) => row.expenseDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "Place of work",
      selector: (row: { expensePlacewrk: any }) => row.expensePlacewrk,
      sortable: true,
      width: "150px",

      wrap: true,
    },
    {
      name: "Requested Expenses",
      selector: (row: { expenseReqAmt: string }) => row.expenseReqAmt,
      sortable: true,
      width: "190px",
    },
    {
      name: "Approved Expenses",
      selector: (row: { expenseApprovedAmt: string }) => row.expenseApprovedAmt,

      sortable: true,
      width: "190px",
    },

    {
      name: "Final Expenses",
      selector: (row: { expenseFinalAmt: string }) => row.expenseFinalAmt,
      sortable: true,
      width: "190px",
    },
    {
      name: "Trip Type",
      selector: (row: { tripType: string }) => row.tripType,
      sortable: true,
      width: "130px",
    },
    {
      name: "Remarks",
      selector: (row: { expenseNote: string }) => row.expenseNote,
      sortable: true,
      // wrap:true,
      width: "190px",
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <button
          onClick={() => handleExpenseView(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
        >
          <FaEye style={{ fill: "#fff" }} /> View
        </button>
      ),
    },
  ];

  const handleExpenseView = (e: any) => {
    Navigate("/singleDayExpense", {
      state: {
        employeeData: {
          ...location?.state?.employeeData,
          ...e,
        },
      },
    });
  };
  const requiredFields:any = {
    Name: "Name",
    Email: "Email",
    EmployeeCode: "EmployeeCode",
    Username: "Username",
    Role: "RoleName",
    Position: "PositionName",
    ReportTo: "ReportingName",
    LastLogin: "LastLogin",
    JoiningDate: "JoinDate",
    DateOfBirth: "BirthDate",
    Contact: "Phone",
    Date: "Date",
    "StartTime-EndTime": "Time",
    VisitCount: "VisitCount",
    TotalDaysExpense: "TotalDaysExpense",
  };

  const { data: dailyCalls,isLoading } = useDailyCallByAttendance({
    enabled: true,
    params: {
      attendance_id: location?.state?.e?.raw?.AttendanceId,
      page:filtersState.page,
      limit:filtersState.limit,
      search:filtersState.search
    },
  });

  const { data: singleDateExpnese,isLoading:ExpenseLoad } = useGetExpenseSingleDateById({
    enabled: true,
    params: {
      date: location?.state?.e?.raw?.Date,
    },
    id: location?.state?.employeeData?.EmployeeId,
  });

  console.log("expens data", singleDateExpnese);

function formatExpenseResponse(input: any) {
  // If input.data is missing or empty, return an empty expenses array
  if (!input.data || (Array.isArray(input.data) && input.data.length === 0)) {
    return {
      statusCode: input.statusCode,
      message: input.message,
      timestamp: input.timestamp?.date
        ? new Date(input.timestamp.date.replace(" ", "T")).toISOString()
        : null,
      expenses: [], // empty array
    };
  }

  const raw = input.data;

  const formattedExpense = {
    expId: raw.ExpId,
    companyId: raw.CompanyId,
    employeeId: raw.EmployeeId,
    orgunitId: raw.OrgunitId,
    budgetId: raw.BudgetId,
    expenseDate: raw.ExpenseDate,
    expenseTrip: raw.ExpenseTrip,
    expensePlacewrk: raw.ExpensePlacewrk,
    tripType: raw.TripType,
    tripCurrency: raw.TripCurrency,
    expenseReqAmt: raw.ExpenseReqAmt,
    expenseApprovedAmt: raw.ExpenseApprovedAmt,
    expenseAdditionalAmt: raw.ExpenseAdditionalAmt,
    expenseTaxAmt: raw.ExpenseTaxAmt,
    expenseFinalAmt: raw.ExpenseFinalAmt,
    expenseStatus: raw.ExpenseStatus,
    expenseMode: raw.ExpenseMode,
    expenseNote: raw.ExpenseNote,
    readflag: raw.Readflag,
    createdAt: raw.CreatedAt,
    updatedAt: raw.UpdatedAt,
    pin: raw.Pin,
    deviceName: raw.DeviceName,
    deviceBattery: raw.DeviceBattery,
    deviceTime: raw.DeviceTime,
    settledAmount: raw.SettledAmount,
    settledDate: raw.SettledDate,
    settledDesc: raw.SettledDesc,
    doVerify: raw.DoVerify,
    isDuplicateCheck: raw.IsDuplicateCheck,
    isDuplicateFound: raw.IsDuplicateFound,
  };

  const rawTimestamp = input.timestamp?.date;
  const parsedTimestamp = rawTimestamp
    ? new Date(rawTimestamp.replace(" ", "T")).toISOString()
    : null;

  console.log("expense data", input.data);

  return {
    statusCode: input.statusCode,
    message: input.message,
    timestamp: parsedTimestamp,
    expenses: [formattedExpense],
  };
}


  console.log('=========> ky data aaya',formatExpenseResponse)
  const [formattedExpense, setFormattedExpense] = useState<any[]>([]);

  useEffect(() => {
    if (singleDateExpnese?.data) {
      const formatted = formatExpenseResponse(singleDateExpnese);
      setFormattedExpense(formatted?.expenses); // set only the array
    }
  }, [singleDateExpnese]);

  console.log("Formatted:", formattedExpense[0]);

  const formattedEmployeeData = {
    ...location.state.employeeData,
    ["Date"]: location.state.e.Date,
    ["TotalDaysExpense"]: formattedExpense[0]?.expenseReqAmt,
    ["VisitCount"]: location.state?.e?.TotalCalls,
    ["Time"]: `${location.state.e.StartTime}-${location.state.e.EndTime}`,
  };

  // const FormattedData=formatExpenseResponse(singleDateExpnese)

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleDailyCallsExcel = async () => {
  try {
    const appToken = localStorage.getItem("Apptoken") || "";
    const params = new URLSearchParams();

       params.append("attendance_id", location?.state?.e?.raw?.AttendanceId);

    // Include 'search' only if it has a non-empty value
    if (filtersState.search && filtersState.search.trim() !== "") {
      params.append("search", filtersState.search.trim());
    }

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getDailyCallsByAttendanceExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "DailyCallsData.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }
};

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  return (
    <div>
      <PageHeader title={`${location.state.e.Date}`} />
      <div
        // className="container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0px", // Spacing between the cards
          justifyContent: "space-between",
          padding: "0px 20px 0px 20px",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1",
            minWidth: "100%",
            maxWidth: "100%",
            paddingBottom: "20px",
          }}
        >
          <EmployeeProfileCard
            media={location?.state?.employeeData?.EmployeeMedia}
            employeeData={formattedEmployeeData}
            requiredFields={requiredFields}
            customStyles={CustomStyle}

          />
        </div>
        <div
          style={{
            flex: "1",
            minWidth: "100%",
            maxWidth: "100%",
            paddingBottom: "20px",
          }}
        >
          <BasicDataTable
            Title="Daily Calls"
            paginationTotalRows={dailyCalls?.data?.recordsTotal}
            SearchPlaceholder="Search by outlet code & name"
            columns={CallsListColumn()}
            data={dailyCalls?.data?.data || []}
               showSpinner={isLoading}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        dynamicHeightOnRowsPerPage={true}
            topLeftAlignContent={
            <>
            <button
              onClick={handleDailyCallsExcel}
              className="btn btn-primary"
              style={{ borderRadius: "20px", padding: "5px 10px", width: "fit-content" }}
            >
              Excel
            </button>

            </>
          }
          />
        </div>
        <div style={{ flex: "1", minWidth: "100%", maxWidth: "100%" }}>
          <BasicDataTable
          showSpinner={ExpenseLoad}
            Title="Expenses"
            columns={ExpenseListColumn(handleExpenseView)}
            data={formattedExpense || []}
            search={false}
          />
        </div>
      </div>
    </div>
  );
};
export default DailyCallView;
